import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { globalEnv } from '../../connection/global/global.env';
import { RequestService } from 'src/app/data/handlers/request/request.service';
import { recaptchaApi } from 'src/app/data/networking/api/recaptcha/recaptcha.api';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  constructor(private http:HttpClient,
              private req: RequestService) {}

  getEvaluationRecaptcha(data: object) {
    return this.http.post(`${globalEnv.recaptcha}${recaptchaApi.configurationGcloud}`, data);
  }

  getConfigurationRecaptcha() {
    const url = `${globalEnv.multiCountry}${recaptchaApi.configurationRecaptcha}`;
    return this.req.get(url, null, null, null, null, true);
  }
}